import IconButton from "@ui-kit/form/IconButton/IconButton.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { ItemHeaderProps } from "./ItemHeader.props";

const ItemHeader = ({
  headerVals,
  removeItem,
  disableRemoveButton,
}: ItemHeaderProps) => {
  const { t } = useTranslation("seating");

  return (
    <Flex>
      {/* Info display for seating cart items */}
      {headerVals.map((headerVal) => {
        return (
          <Flex
            key={`${headerVal.id}-${headerVal.title}-${headerVal.value}`}
            direction="column"
            flex="1 1 auto"
          >
            <Text fontSize="xs">{headerVal.title}</Text>
            <Text fontWeight="bold" fontSize="sm" letterSpacing="-0.5px">
              {headerVal.value}
            </Text>
          </Flex>
        );
      })}
      {/* Deletion button for seating cart items */}
      <Flex
        direction="column"
        flex="1 1 5%"
        justifyContent="center"
        alignItems="flex-end"
      >
        <IconButton
          aria-label={t("Remove item", { ns: "common" })}
          boxSize="element.xl"
          onClick={() => {
            if (removeItem) {
              removeItem();
            }
          }}
          disabled={disableRemoveButton}
          backgroundColor="transparent"
          _hover={{
            backgroundColor: "transparent",
          }}
          _active={{
            backgroundColor: "transparent",
          }}
          iconName="Trash.Outline"
          iconColor="font.dark"
        />
      </Flex>
    </Flex>
  );
};

export default ItemHeader;
